// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1D1WC","tab":"Tabs_tab__3sWzT","tabActive":"Tabs_tabActive__3G_OA"};